import type { CostAndCharge } from 'models/streaming/costsAndCharges';
import { connect } from 'react-redux';
import { getFormQuoteDetails, getFormQuoteId, getRegulationInfos } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

interface StateProps {
  quoteId: string | undefined;
  costsAndChargesResults: CostAndCharge[];
  currency: string;
}
export type RegulatoryProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteId = getFormQuoteId(state, workspaceType, tabId);
  const regulationInfos = getRegulationInfos(state, tabId, quoteId as string);
  const quoteDetails = getFormQuoteDetails(state, 'static', tabId);
  const costsAndCharges = regulationInfos?.costAndCharge;
  const currency = quoteDetails?.Currency as string;

  const costsAndChargesResults: CostAndCharge[] = costsAndCharges || [];

  return {
    quoteId,
    currency,
    costsAndChargesResults,
  };
};

export const connectRegulatory = connect(mapStateToProps);
